export var fr = {
    required: 'Requis',
    deprecated: 'Obsolète',
    deprecated_and_sunset_on: 'Cette opération est obsolète et sera supprimée le ${1}.',
    stability_experimental: 'Expérimental',
    stability_alpha: 'Alpha',
    stability_beta: 'Bêta',
    copy_to_clipboard: 'Copier dans le presse-papiers',
    copied: 'Copié',
    no_content: 'Aucun contenu',
    unresolved_reference: 'Référence non résolue',
    circular_reference: 'Référence circulaire',
    read_only: 'Lecture seule',
    write_only: 'Écriture seule',
    optional: 'Optionnel',
    min: 'Min',
    max: 'Max',
    nullable: 'Nullable',
    body: 'Corps',
    payload: 'Charge utile',
    headers: 'En-têtes',
    authorizations: 'Autorisations',
    responses: 'Réponses',
    path_parameters: 'Paramètres de chemin',
    query_parameters: 'Paramètres de requête',
    header_parameters: 'Paramètres d’en-tête',
    attributes: 'Attributs',
    test_it: 'Tester',
    information: 'Information',
    success: 'Succès',
    redirect: 'Redirection',
    error: 'Erreur',
    show: 'Afficher',
    hide: 'Masquer',
    available_items: 'Éléments disponibles',
    child_attributes: 'Attributs enfants',
};
